// Return-snapshot read + photo-resolve API client (#2140). The backend
// snapshot endpoints (#2138) are read-only; the photo-download-url POST is
// scoped to the snapshot (objectKey only — NO itemId/boxId), because a live
// item/box row may have been edited after the return, so the live key 404s.

import { z } from 'zod';
import {
  RequestReturnSnapshotDetailSchema,
  RequestReturnSnapshotListItemSchema,
  StorageDownloadUrlResponseSchema,
  type RequestReturnSnapshotDetail,
  type RequestReturnSnapshotListItem,
  type StorageDownloadUrlResponse,
} from '@magimp/shared';
import { request } from '../client.js';

const SnapshotListSchema = z.array(RequestReturnSnapshotListItemSchema);

export function fetchRequestSnapshots(
  requestId: string,
  opts: { signal?: AbortSignal } = {},
): Promise<RequestReturnSnapshotListItem[]> {
  return request<RequestReturnSnapshotListItem[]>(
    `/requests/${encodeURIComponent(requestId)}/snapshots`,
    { method: 'GET' },
    opts.signal ? { signal: opts.signal } : {},
    SnapshotListSchema,
  );
}

export function fetchRequestSnapshot(
  requestId: string,
  snapshotId: string,
  opts: { signal?: AbortSignal } = {},
): Promise<RequestReturnSnapshotDetail> {
  return request<RequestReturnSnapshotDetail>(
    `/requests/${encodeURIComponent(requestId)}/snapshots/${encodeURIComponent(snapshotId)}`,
    { method: 'GET' },
    opts.signal ? { signal: opts.signal } : {},
    RequestReturnSnapshotDetailSchema,
  );
}

export function requestSnapshotPhotoDownloadUrl(
  requestId: string,
  snapshotId: string,
  objectKey: string,
): Promise<StorageDownloadUrlResponse> {
  return request<StorageDownloadUrlResponse>(
    `/requests/${encodeURIComponent(requestId)}/snapshots/${encodeURIComponent(
      snapshotId,
    )}/photo-download-url`,
    {
      method: 'POST',
      body: JSON.stringify({ objectKey }),
      headers: { 'content-type': 'application/json' },
    },
    {},
    StorageDownloadUrlResponseSchema,
  );
}
